common.View.create('crud::datatable.columns.Interactive', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initShowInteractiveField();
        this.initOnInputChange();
    },

    initOnInputChange() {
        // On input or select change; Begin interactive save
        this.element.find('input, select').on('blur keyup', (event) => {
            // On blur or on enter
            if (event.type === 'blur' || event.keyCode === 13) {
                this.initOnInteractiveFieldChange(event);
            }
        });
    },

    initShowInteractiveField()
    {
        $('body').on('click', (event) => {
            // If field is available
            if( !this.element.find('.field').length )
                return;

            // If target click is not the container or descendant of the container
            if (!this.element.is(event.target) && this.element.has(event.target).length === 0) {
                // Hide field or not
                this.element
                    .find('.value')
                        .show()
                        .end()
                    .find('.field')
                        .addClass('hidden')
                        .end();

            } else {
                // Hide field or not
                this.element
                    .find('.value')
                        .hide()
                        .end()
                    .find('.field')
                        .removeClass('hidden')
                        .end();
            }
        });
    },

    triggerFieldActive(fieldActive = null)
    {
        // If field is available
        if( this.element.find('.field').length ) {
            // Hide field or not
            this.element
                .find('.value')
                    .toggle(fieldActive)
                    .end()
                .find('.field')
                    .toggleClass('hidden', fieldActive)
                    .end();
        }
    },

    initOnInteractiveFieldChange(event)
    {
        let postData = {};

        // Add current field data
        postData['fieldName'] = $(event.currentTarget).attr('name');
        postData[$(event.currentTarget).attr('name')] = $(event.currentTarget).val();

        // Run by action?
        if( $(event.currentTarget).data('action') ) {
            $.ajax({
                url: $(event.currentTarget).data('action'),
                type: 'PATCH',
                data: postData,
                success: (data) => {
                    this.initRemoveInteractiveField(data)
                }
            });

            return true;
        }

        // Add model and id to request
        postData['model'] = $(event.currentTarget).data('model');
        postData['id'] = $(event.currentTarget).data('id');

        // Else run by model and id to update
        $.post('/admin/quick-update-model', postData)
            .done((data) => {
                this.initRemoveInteractiveField(data);
            });
    },

    initRemoveInteractiveField(value)
    {
        // Hide field again
        this.element
            .find('.value')
                .html(value)
                .show()
                .end()
            .find('.field')
                .addClass('hidden')
                .end();
    }

});
